export const MAIL_SENDING = "mail_sending"
export const MAIL_SENT = "mail_sent"
export const MAIL_ERROR = "mail_error"
